export default __webpack_public_path__ + "static/Leblanc-Logo-12581b116198e49c5b21938f9c8af673.png";